"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IlDirettoreStrategico() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="il-direttore-strategico" className="dark bg-background text-foreground relative w-full overflow-hidden py-32 md:py-48 px-6 md:px-12 lg:px-24 flex items-center min-h-[80vh]">
      {}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none bg-cover bg-center bg-no-repeat grayscale mix-blend-luminosity bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/strategic_director_portrait_bw.png)]" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 w-full max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
        {}
        <div className="md:col-span-3 lg:col-span-2 flex justify-start md:justify-end items-start md:items-center">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-secondary uppercase tracking-[0.15em] md:[writing-mode:vertical-rl] md:rotate-180 whitespace-nowrap">
            Il Direttore Strategico
          </h2>
        </div>

        {}
        <div className="md:col-span-9 lg:col-span-10 flex flex-col justify-center">
          <div className="max-w-4xl">
            <p className="font-sans text-[28px] md:text-[32px] leading-[1.4] text-foreground font-light tracking-tight">
              Task force d'élite. 15 anni di esperienza, padronanza linguistica
              nativa e profonda applicazione della psicologia comportamentale per
              dominare le negoziazioni internazionali.
            </p>
            
            <div className="mt-12 md:mt-16">
              <span className="font-sans text-[28px] md:text-[32px] leading-[1.4] text-foreground font-medium border-b-[4px] border-primary pb-2 inline-block">
                Solo 5 progetti partner all'anno
              </span>
              <span className="font-sans text-[28px] md:text-[32px] leading-[1.4] text-foreground font-light ml-2">
                per controllo assoluto.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}